// extracted by mini-css-extract-plugin
export default {"contentbox":"AddTracking_contentbox__U8v4b","orderid":"AddTracking_orderid__pnhJj","btn_start":"AddTracking_btn_start__F8zXc","animate-rotate":"AddTracking_animate-rotate__nfZb1"};